import { StyleSheet, css } from 'aphrodite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import BlurbSection from '../components/BlurbSection'
import HeroSection from '../components/HeroSection'
import LandingCard from '../components/LandingCard'
import LandingSection from '../components/LandingSection'
import TitleBlurbSection from '../components/TitleBlurbSection'
import LandingFooter from '../components/navigation/LandingFooter'
import LandingHeader from '../components/navigation/LandingHeader'

export default function AboutPage() {
  const navigate = useNavigate()

  const handleJoinCommunityClick = () => {
    window.scrollTo(0, 0)
    navigate('/register')
  }

  return (
    <div className={css(styles.container)}>
      <LandingHeader />
      <HeroSection
        subtitle="About DayDaCo"
        title="A VISION FOR A DIGITAL FUTURE"
        description="Founded in San Francisco in 2018, the Ecosystem was designed by a
        seasoned Dump Truck Driver and Contractor who experienced the Industry’s everyday challenges
        and envisioned a digital environment for the Dump Truck marketplace."
        imageSrc="/about_hero3.png"
        imageAlt="A vision for a digital future"
      />
      <BlurbSection text="A new digital world for the Dump Truck Industry defined by Transparency, Trust, and Collaboration. More than just software, the Ecosystem is a place where transparency and efficiency guide every hauling project, every role, and every mile." />

      <section className={css(styles.cardSection)}>
        <LandingCard
          number={1}
          title="BUILT ON TRANSPARENCY, TRUST, & COLLABORATION"
          description="Beyond efficiency, the Ecosystem connects all stakeholders through shared data, insights, and mutual respect. Transparency, Trust, and Collaboration are the pillars of the Community."
          backgroundColor="#D6E6F5"
        />
        <LandingCard
          number={2}
          title="DESIGNED FOR SUSTAINABILITY AND SCALE"
          description="With interconnected, modular digital Tags, Project Terms, Dispatches, and semi-automated Invoices and Status and Progress Reports, the Ecosystem removes all paper, eliminates unnecessary vehicle trips, reduces greenhouse gas emissions, and creates a more sustainable Dump Truck Industry model."
          backgroundColor="#F8FFD3"
        />
        <LandingCard
          number={3}
          title="IDEA TO IMPACT"
          description="From a small idea to a growing Ecosystem, we continue to evolve. Behind every milestone is a team driven by people who believe that real-world problems deserve real digital solutions. It is this community who brings it all to life."
          backgroundColor="#D3FFEA"
        />
      </section>

      <TitleBlurbSection
        title="LOOKING AHEAD"
        description="The vision is clear: A Dump Truck Community acting upon Transparency, Trust, and Collaboration for the Community to thrive."
      />

      <LandingSection
        title="JOIN THE ECOSYSTEM"
        description="Work smarter with real-time updates, instant data access, and modular, digital templates and workflows. Cut down on paperwork, build trust, and reduce unnecessary driving – all in one Ecosystem."
        imageSrc="/ecosystem2.webp"
        imageAlt="Construction Team"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
      />

      <LandingFooter />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  cardSection: {
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '40px 1rem',
    alignItems: 'stretch',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      gap: '20px',
      padding: '60px 2rem',
      alignItems: 'stretch',
    },
    '@media (min-width: 1024px)': {
      gap: '24px',
      padding: '80px 3rem',
      minHeight: '60vh',
      alignItems: 'stretch',
    },
  },
})
